import { Tenant } from './tenant';
import { Organization } from './organization';

export class TriggerRule {
  name: string;
  entityType: string;
  expression: string;
  type: string;
  appliedTo: string;
  tenant: Tenant;
  organization: Organization;
  category: 'ALARM' | 'WARNING';
  disabledRepeatedEvents: boolean;
}
